<section class="last-updated-by">
  <div class="text-container">
    <gc-text [variant]="'bodyBold'">{{
      'reportInfo.lastUpdatedBy' | translate
    }}</gc-text>
    <gc-text>{{ lastUpdatedByString }}</gc-text>
  </div>
</section>
<hr />
<section class="object-name">
  <div class="text-container">
    <gc-text [variant]="'bodyBold'">{{
      (pointType === 'HP' ? 'reportInfo.address' : 'reportInfo.objectName')
        | translate
    }}</gc-text>
    <gc-text>{{ objectName }}</gc-text>
  </div>
</section>
<hr />
<section class="status">
  <div class="text-container">
    <gc-text [variant]="'bodyBold'">{{
      'reportInfo.status' | translate
    }}</gc-text>
    <gc-text>{{ 'reportStatus.' + reportStatus | translate }}</gc-text>
  </div>
  <!--Add future status icon here - style class .status to position it correctly-->
</section>
